module.exports = __webpack_public_path__ + "static/media/UserDefaultAvatar.849849ff.svg";